import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20soft%20pastel%20fashion%20elements%20floating%20sneakers%20hoodies%20caps%20and%20accessories%20in%20dreamy%20ethereal%20arrangement%20on%20warm%20cream%20background%20with%20gentle%20gradients%20of%20peach%20and%20sage%20green%20soft%20diffused%20lighting%20magazine%20editorial%20style%20clean%20aesthetic%20high%20end%20fashion%20photography%20composition&width=1600&height=900&seq=hero-bg-v2-sugargoo&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion product collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20 md:py-28">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-2 rounded-full bg-accent-100/80 text-accent-800 text-sm font-medium mb-6">
            Independent Educational Resource
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-6 animate-fade-in-up animation-delay-100">
          Sugargoo Spreadsheet — <br className="hidden sm:block" />
          <span className="text-primary-600">Find The Best Products Faster</span>
        </h1>

        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-10 animate-fade-in-up animation-delay-200 leading-relaxed">
          Discover thousands of organized product finds, shopping guides, reviews and comparison tools designed to make your Sugargoo shopping experience easier, safer and smarter.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-300">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-white font-semibold text-base rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line"></i>
            Sugargoo Spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-foreground-950 text-background-50 font-semibold text-base rounded-full hover:bg-foreground-800 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-flashlight-line"></i>
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10 animate-fade-in-up animation-delay-400">
          {['Updated Resources', 'Independent Research', 'Beginner Friendly', 'Shopping Guides'].map((badge) => (
            <span key={badge} className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-check-line text-accent-600 text-base"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-fade-in-up animation-delay-500">
        <a href="#categories" className="flex flex-col items-center gap-2 text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">
          <span className="text-xs font-medium">Explore Categories</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}